import { useEffect, useState } from 'react'
import { FiCheckCircle, FiX } from 'react-icons/fi'
import { flyteSyncCompleteMessage, onFlyteSyncSettled, watchFlyteSyncInBackground, type FlyteSyncState } from '@/services/flyteSync'

const FlyteSyncToast = () => {
  const [toast, setToast] = useState<{ id: number; ok: boolean; message: string } | null>(null)

  useEffect(() => {
    watchFlyteSyncInBackground()
    return onFlyteSyncSettled((job: FlyteSyncState) => {
      setToast({
        id: Date.now(),
        ok: job.status === 'completed',
        message: flyteSyncCompleteMessage(job),
      })
    })
  }, [])

  if (!toast) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: '100px',
        right: '16px',
        zIndex: 9999,
        width: 'min(420px, calc(100vw - 32px))',
        backgroundColor: toast.ok ? '#F1FAF5' : '#FEF2F2',
        border: `1px solid ${toast.ok ? '#B9DEC9' : '#FECACA'}`,
        color: toast.ok ? '#137A43' : '#B91C1C',
        borderRadius: '8px',
        padding: '12px 14px',
        fontFamily: 'Lexend Deca',
        fontSize: '13px',
        lineHeight: '20px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
      }}
    >
      <div className="flex items-start gap-2">
        <FiCheckCircle className="w-4 h-4 mt-0.5 shrink-0" />
        <span className="flex-1">{toast.message}</span>
        <button type="button" onClick={() => setToast(null)} className="shrink-0 opacity-70 hover:opacity-100">
          <FiX className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}

export default FlyteSyncToast
